import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Transaction } from '../models/transaction';

@Injectable({
    providedIn: 'root',
})
export class TransactionsService {
    constructor(private http: HttpClient) {}

    public getTransactionById(transactionId: string): Observable<Transaction> {
        return this.http.get<Transaction>(`${environment.api_url}/transactions/${transactionId}`);
    }

    public getTransactions(
        pageNumber: number,
        pageSize: number,
        searchTerm: string,
        sort: {
            [key: string]: any;
        },
        filter: {
            [key: string]: any;
        },
        fromDate?: string,
        toDate?: string
    ) {
        // Convert sort object to a JSON string for HttpParams
        const sortString = sort ? JSON.stringify(sort) : '';
        const filterString = filter ? JSON.stringify(filter) : '';
        const params = new HttpParams()
            .set('searchTerm', searchTerm)
            .set('pageSize', pageSize)
            .set('pageNumber', pageNumber)
            .set('sort', sortString)
            .set('filter', filterString)
            .set('fromDate', fromDate || null)
            .set('toDate', toDate || null);
        return this.http.get(`${environment.api_url}/transactions/admin-search`, {
            params,
        });
    }

    public updateTransaction(
        id: string,
        status: {
            value: string;
            name: string;
            _id: string;
            notes: string | null;
        },
        approvalDoc?: File
    ) {
        // Create a new FormData instance
        const formData = new FormData();

        // Add the status fields to FormData
        Object.keys(status).forEach((key) => {
            const value = (status as any)[key];
            formData.append(key, value instanceof Date ? value.toISOString() : value || '');
        });

        // Add the approvalDoc if it exists
        if (approvalDoc) {
            formData.append('approvalDoc', approvalDoc, approvalDoc.name);
        }

        // Send the HTTP request
        return this.http.patch(`${environment.api_url}/transactions/${id}`, formData, {
            headers: { enctype: 'multipart/form-data' }, // Inform the server of the FormData format
        });
    }

    public exportTransactionList(
        fields: Array<string>,
        pageNumber: number,
        pageSize: number,
        searchTerm: string,
        sort: {
            [key: string]: any;
        },
        filter: {
            [key: string]: any;
        },
        fromDate?: string,
        toDate?: string
    ) {
        return this.http.post(
            `${environment.api_url}/transactions/admin-transaction-export`,
            { pageNumber, pageSize, searchTerm, sort, filter, fromDate, toDate, fields },
            { observe: 'response', responseType: 'blob' }
        );
    }
}
